import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './router/permission'
import axios from 'axios'
import common from '@/common/common.js'

import './plugins/element.js'
import './assets/js/pcrem.js'
import 'element-ui/lib/theme-chalk/display.css';
import './assets/css/reset.css'

import VueGeolocation from 'vue-browser-geolocation';
Vue.use(VueGeolocation);

import VueAMap from 'vue-amap';
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: '608d75903d29ad471362f8c58c550daf',
  plugin: [
    "AMap.AutoComplete", //输入提示插件
    "AMap.PlaceSearch", //POI搜索插件
    "AMap.Scale", //右下角缩略图插件 比例尺
    "AMap.OverView", //地图鹰眼插件
    "AMap.ToolBar", //地图工具条
    "AMap.MapType", //类别切换控件，实现默认图层与卫星图、实施交通图层之间切换的控制
    "AMap.PolyEditor", //编辑 折线多，边形
    "AMap.PolygonEditor", //编辑 折线多，边形
    "AMap.CircleEditor", //圆形编辑器插件
    "AMap.Geolocation" //定位控件，用来获取和展示用户主机所在的经纬度位置
  ],
  v: '1.4.15'
});

axios.defaults.timeout = 10000
axios.defaults.baseURL = 'https://www.csstss.com/api';

Vue.prototype.$http = axios
Vue.config.productionTip = false
Vue.prototype.common = common;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
